import { CalendarScheduledSectionServant } from '../../servants/calendar_scheduled_section_servant';
import { ScheduledSectionsQuery } from '../../../course_scheduler/queries/scheduled_sections_query';
import { ScheduledSectionStatusServant } from '../../../course_scheduler/servants/scheduled_section_status_servant';
import { SectionInfoServant } from '../../../sections/servants/section_info_servant';
import { ScheduledSectionServant } from '../../../course_scheduler/servants/scheduled_section_servant';
import { ScheduledSectionTileServant } from '../../../course_scheduler/servants/scheduled_section_tile_servant';
import { ISection } from '../../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
import { ISectionsDatasource } from '../../../sections/datasources/sections_datasource';
import { IModel, ICommand } from 'core-ts-types';
import { SectionSwapServant } from '../../../../swap/servants/section_swap_servant';
import { SectionSwapModel } from '../../../../swap/models/course_section_swap_model';
import { TermCourseServant } from '../../../term_courses/servants/term_course_servant';
import { ITermCoursesDatasource } from '../../../term_courses/datasources/term_courses_datasource';
import { AllSectionsQuery } from '../../../course_scheduler/queries/all_sections_query';

class CalendarScheduledSection {
  private section: ISection;
  private sectionId: number;
  private locationAndTimes: any;
  private sectionLocation: string;
  private canAddFromWaitlist: boolean;
  private isMultiSection: boolean;
  private isStatusPending: boolean;
  private canSwap: boolean;
  private isWaitlistEnabled: boolean;
  private showMessageWarning: boolean;
  private isRegisteredNotDroppable: boolean;

  constructor(
    private ngScheduledSectionTileServant: ScheduledSectionTileServant,
    private ngScheduledSectionServant: ScheduledSectionServant,
    private ngSectionInfoServant: SectionInfoServant,
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant,
    private ngScheduledSectionsQuery: ScheduledSectionsQuery,
    private $anchorScroll: any,
    private $state: ng.ui.IStateService,
    private ngCourseSectionSwapModel: SectionSwapModel,
    private ngSectionsDatasource: ISectionsDatasource,
    private ngCalendarScheduledSectionServant: CalendarScheduledSectionServant,
    private ngSectionSwapServant: SectionSwapServant,
    private ngTermCourseServant: TermCourseServant,
    private ngTermCoursesDatasource: ITermCoursesDatasource,
    private ngAllSectionsQuery: AllSectionsQuery,
    private saveSwapFromSectionCommand: ICommand
  ) {}

  initialize() {
    this.section = _4.find(
      this.ngSectionsDatasource.metasource().derived(),
      (section: ISection) => section.id === this.sectionId
    );
    this.locationAndTimes = this.ngSectionInfoServant.calculateSectionTimes(this.section);
    this.sectionLocation = this.ngSectionInfoServant.getSectionLocationString(this.section);
    this.canAddFromWaitlist =
      this.ngScheduledSectionServant.canAddFromWaitlist(this.section) &&
      _4.isEqual(this.section._isEligibleForRegistration, true);
    this.isMultiSection = this.ngScheduledSectionServant.isSectionMultiSection(this.section);
    this.isStatusPending = this.ngScheduledSectionStatusServant.isStatusPending(this.section);
    this.isWaitlistEnabled = this.ngScheduledSectionTileServant.isWaitlistEnabled();
    this.showMessageWarning = this.ngCalendarScheduledSectionServant.showWarningIcon(this.section);
    this.canSwap =
      this.ngScheduledSectionStatusServant.isStatusRegistered(this.section) &&
      this.ngSectionSwapServant.isSwapFeatureEnabled() &&
      this.ngScheduledSectionStatusServant.isDroppable(this.section);
    this.isRegisteredNotDroppable =
      this.ngScheduledSectionStatusServant.isStatusRegistered(this.section) &&
      (!this.ngScheduledSectionStatusServant.isDroppable(this.section) ||
        !this.ngScheduledSectionStatusServant.hasDropDates(this.section));
  }

  $onInit() {
    this.initialize();
  }

  $onChanges() {
    this.initialize();
  }
  scrollToTile() {
    this.$anchorScroll(`section-${this.section.cd}`);
  }

  gotoSwap() {
    const section = _4.find(this.ngSectionsDatasource.read(), { id: this.sectionId });
    this.saveSwapFromSectionCommand(section).then(() => this.ngSectionSwapServant.gotoSwapSectionMode(section));
  }
}

class CalendarScheduledSectionComponent implements ng.IComponentOptions {
  public bindings: ng.IComponentOptions['bindings'];
  public controller: ng.IComponentOptions['controller'];
  public templateUrl: ng.IComponentOptions['templateUrl'];
  constructor() {
    this.bindings = {
      sectionId: '<'
    };
    this.controller = CalendarScheduledSection;
    this.templateUrl =
      'capability-ng-scheduler/src/views/calendar/components/calendar_scheduled_section/calendar_scheduled_section.html';
  }
}
angular
  .module('capability-ng-scheduler')
  .component('calendarScheduledSection', new CalendarScheduledSectionComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/calendar/components/calendar_scheduled_section/calendar_scheduled_section.ts